export default __webpack_public_path__ + "static/media/news-image.4f0a95ab.webp";